import { ArticleParagraph1, UIHeading2 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';
import Truncate from 'react-truncate';

import { CollapseButton } from '../CollapseButton';
import * as style from './style.css';

export const STATS_MAX_LINES = 1;

export type TPossibleAssignmentStatTheme = 'office' | 'warehouse' | 'trade-area' | 'manufacture';
export type TPossibleAssignmentStatTitle = 'Производство' | 'Офис' | 'Склад' | 'Торговая площадь';

export interface IPossibleAssignmentStat {
  theme?: TPossibleAssignmentStatTheme;
  title: TPossibleAssignmentStatTitle;
}

export interface IPossibleAssignmentLayoutProps {
  stats: IPossibleAssignmentStat[];
  moreStatsText: string;
}

export const PossibleAssignmentLayout: React.FC<IPossibleAssignmentLayoutProps> = ({ moreStatsText, stats }) => {
  const [truncated, setTruncated] = React.useState<boolean>(false);
  const [showMore, setShowMore] = React.useState(false);

  /* istanbul ignore next */
  const handleToggle = React.useCallback(() => {
    setShowMore(value => !value);
  }, []);

  return (
    <div>
      <UIHeading2>Возможное назначение</UIHeading2>

      <ul className={style['list']}>
        {stats.map(({ theme, title }, index) => (
          <li key={title + index} className={cn(theme && style[theme])}>
            <ArticleParagraph1 color="black_100">{title}</ArticleParagraph1>
          </li>
        ))}
      </ul>

      <div className={style['more-stats-text']}>
        <Truncate lines={!showMore && STATS_MAX_LINES} onTruncate={setTruncated} ellipsis={<span>...</span>}>
          {`Ещё: ${moreStatsText}`}
        </Truncate>
      </div>

      {(truncated || showMore) && <CollapseButton onClick={handleToggle} isCollapsed={!showMore} />}
    </div>
  );
};
